// stores/reducer_bedsRealtime.js
import { createSlice } from "@reduxjs/toolkit";

export const BedsRealtimeSlice = createSlice({
    name: "bedsRealtime",
    initialState: {
        rssi_map: {},
        volume_map: {}
    },
    reducers: {
        UPDATE_RSSI: (state, action) => {
            const { bedId, value } = action.payload;
            state.rssi_map[bedId] = value;
        },
        UPDATE_VOLUME: (state, action) => {
            const { bedId, value } = action.payload;
            state.volume_map[bedId] = value;
        },
        RESET_REALTIME: (state) => {
            state.rssi_map = {};
            state.volume_map = {};
        }
    },
});

export const { UPDATE_RSSI, UPDATE_VOLUME, RESET_REALTIME } = BedsRealtimeSlice.actions;
export default BedsRealtimeSlice.reducer;
